'use client';

import {Drawer, DrawerProps} from '@mui/material';
import {ActivityService} from '@services/activity/activity.service';
import classNames from 'classnames';
import {PropsWithoutRef, forwardRef, useImperativeHandle} from 'react';
import styles from './MeinDrawer.module.css';
import {useDrawer, withDrawer} from './useDrawer';

export type MeinDrawer = {
    toggle: (isOpen?: boolean) => void;
    className?: string;
};

export const MeinDrawer = withDrawer(
    forwardRef<MeinDrawer, PropsWithoutRef<DrawerProps>>(function MeinDrawer(
        {children, className, anchor = 'right', open, onClose, ...rest},
        ref,
    ) {
        const isOpen = useDrawer(s => s.isOpen);
        const toggle = useDrawer(s => s.toggle);

        useImperativeHandle(ref, () => ({
            toggle,
        }));

        const handleClose = () => {
            ActivityService.logElementClick({
                resource_id: 'btn_hide_modules',
            });
            toggle(false);
        };

        return (
            <Drawer
                ModalProps={{
                    slotProps: {backdrop: {invisible: true}},
                }}
                anchor={anchor}
                variant="temporary"
                open={open ?? isOpen}
                onClose={onClose ?? handleClose}
                className={classNames(styles.drawer, className)}
                keepMounted={false}
                {...rest}
            >
                {children}
            </Drawer>
        );
    }),
);
